/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Col_Expected_ReceiptInputs */

const en_po_col_expected_receipt = /** @type {(inputs: Po_Col_Expected_ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected receipt`)
};

/**
* | output |
* | --- |
* | "Expected receipt" |
*
* @param {Po_Col_Expected_ReceiptInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_col_expected_receipt = /** @type {((inputs?: Po_Col_Expected_ReceiptInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Col_Expected_ReceiptInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_col_expected_receipt(inputs)
});